import { type Country, siteConfig } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types';

export const getCountryFromSite = (site: EmployerSiteName): Country =>
  siteConfig[site].classification.country;
